import { useTranslation } from "@redotech/redo-i18n";
import { RateSourceSelectionCard } from "./rate-source-selection-card";
import { RateSourceSelectionSectionSkeleton } from "./rate-source-selection-section-skeleton";

export function RateSourceSelectionSkeleton() {
  const { t } = useTranslation();

  return (
    <RateSourceSelectionCard title={t("Carrier accounts")}>
      <RateSourceSelectionSectionSkeleton rowWidths={["40px", "48px"]} />
      <RateSourceSelectionSectionSkeleton
        rowWidths={["40px", "112px", "48px"]}
      />
    </RateSourceSelectionCard>
  );
}
